module.exports = __webpack_public_path__ + "static/assets/994067c37d7272bbb1443f8c348329e1.png";